// 设备管理
export default {
    devmanage: " Управление оборудованием",
    uavdevdetails: 'Сведения об устройстве (дрон)',
    life: 'Статистика жизни',
    ptzdevdetails: 'Подробная информация об устройстве (наклонно-поворотное устройство)',
    battydevdetails: 'Сведения об устройстве (интеллектуальная батарея) ',
    rtkdevdetails: 'Сведения об устройстве (RTK) ',
    sn: 'SN',
    devname: 'Название оборудования',
    pinputname: 'Пожалуйста, введите имя устройства',
    pinputsn: 'Пожалуйста, введите SN-код устройства',
    search: 'искать',
    adddev: 'Добавить устройство',
    devtype: 'Тип оборудования',
    devstate: 'состояние устройства',
    networkstate: 'статус сети',
    screen: 'Скрининг',
    devnum: 'Количество оборудования',
    inputtime: 'Время входа',
    vision: 'номер версии',
    dtime: 'Заводское время',
    Atime: 'Время активации',
    SS: 'Общее состояние',
    QXA: 'Аккаунт тысяча саженей',
    operation: 'операция',
    details: 'детали',
    edit: 'редактировать',
    share: 'быстрый обмен',
    QX: 'Настройки Тихиро',
    delete: 'Удалить',
    editdev: 'Изменить устройство',
    devsn: 'оборудование',
    deletes: 'пакетное удаление',
    remarks: 'Замечания',
    uav: 'Дрон',
    znBattery: 'Умный аккумулятор',
    ptz: 'PTZ камеры',
    normal: 'нормальный',
    reparied: 'В ремонте',
    under: 'в обеспечении',
    scrap: 'слом',
    onlin: 'В сети',
    offline: "автономно",
    psearch: 'Пожалуйста, сначала ищите',
    deldevmes: 'Вы не сможете использовать устройство после его удаления. Продолжить?',
    delchedevmes: 'Вы не сможете использовать выбранное устройство после удаления, продолжить?',
    SU: 'Общий пользователь',
    mobile: 'Мобильный телефон',
    flymodel: 'Тип самолета',
    Battery: 'аккумулятор',
    Batterymodel: 'модель батареи',
    defects: 'гарантийный срок',
    BMSv: 'Версия BMS',
    totaltime: 'Общее использованное время',
    cffreq: 'Время зарядки и разрядки',
    reslife: 'Оставшаяся жизнь',
    usefullife: 'Использованная жизнь',
    batterylife: "Статистика автономной работы",
    ptzmodel: 'номер вида PTZ камеры',
    day: 'день',
    firmv: 'Версия прошивки',
    rtk: 'Базовая станция',
    model: 'модель',
    long: 'долгота',
    lat: 'широта',
    basertk: 'Высота базовой станции',
    coverage: 'Покрытие',
    satenum: 'Количество спутников',
    positionlong: 'точность позиционирования',
    positiontype: 'Статус позиционирования',
    NS: 'Статус сети',
    flysn: 'самолет',
    flynum: 'Количество полетов',
    EAV: 'Версия ESC ',
    flytotaltime: 'Общее время полета',
    lifestatistic: 'Статистика жизни',
    Flightv: 'Версия управления полетом',
    gatewayv: 'Версия шлюза',
    Fligh: 'Управление полетом',
    gateway: 'Шлюз',
    radar: 'Наземный радар',
    receiver: 'Приемник',
    parachute: 'парашют',
    elemach: 'электромашина',
    elereg: 'электронное регулирование',
    motor: 'мотор',
    totalflightmil: 'Общий пробег за рейс',
    uavlifestatistic: 'Статистика жизни БПЛА',
    parachuteLife: 'Парашютная жизнь',
    armNumber: 'Рука {0}',
    AS: 'уже поделился',
    WS: 'был поделен',
    month: 'месяц',
    tip_DP: 'Повторяющееся имя устройства, введите повторно',
}